module.exports = __webpack_public_path__ + "img/user-photo-lg.4b21fc27.jpg";